import appConstants from "../../../../../appConstants";
import { MultiSelectFilter } from '@dataGrid/components/columnFilters';
import CommandCellRenderer from '@dataGrid/components/cellRenderer/CommandCellRenderer';

export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
      static getConfiguration({ terminalAccessLabel }) {
        return GridConfig.getDefaultConfiguration({ terminalAccessLabel });
    }

    static CommandCellRenderer(props){
      const commandConfig = {
        editCommand: "editUser",
        editTitle: "Edit User",
        deleteCommand: "deleteUser",
        deleteTitle: "Delete User",
      };
      return <CommandCellRenderer commandConfig={commandConfig} params={{ ...props }} />;
    }

  static getDefaultConfiguration({ terminalAccessLabel }) {
    return {
      title: appConstants.gridNames.TerminalAcces,
      keyColumn: "userId",
      rowSelection: "single",
      defaultColDef: {
        filter: MultiSelectFilter
      },
      columns: [
        {
          headerName: "User ID",
          field: "userId",
          hide: true,
          headerTooltip: "user ID"
        },
        {
          headerName: "Username",
          headerTooltip: "Username",
          field: "userName",
          minWidth: appConstants.columnWidth.TERMINAL_USER,
        },
        {
          headerName: "First Name",
          headerTooltip: "First Name",
          field: "firstName",
          minWidth: appConstants.columnWidth.TERMINAL_FIRSTNAME,

        },
        {
          headerName: "Last Name",
          headerTooltip: "Last Name",
          field: "lastName",
          minWidth: appConstants.columnWidth.TERMINAL_LASTNAME,
        },
        {
          headerName: "Email",
          headerTooltip: "Email",
          field: "email",
          minWidth: appConstants.columnWidth.TERMINAL_EMAIL,
        },
        {
          headerName: "Job Title",
          headerTooltip: "Job Title",
          field: "jobTitle",
          minWidth: appConstants.columnWidth.TERMINAL_JOBTITLE,
        },
        {
          headerName: `Default ${terminalAccessLabel.shortName}`,
          headerTooltip: `Default ${terminalAccessLabel.fullName}`,
          field: "defaultTerminal",
          minWidth: appConstants.columnWidth.TERMINAL_DEFAULTTERMINAL,
        },
        {
          headerName:
            `Accessible ${terminalAccessLabel.shortName}s`,
          headerTooltip:
            `Accessible ${terminalAccessLabel.fullName}s`,
          field: "otherTerminals",
          tooltipField: "otherTerminals",
          minWidth: appConstants.columnWidth.TERMINAL_TERMINALLIST,
        },
        {
          headerName: "Commands",
          headerTooltip: "Commands",
          field: "command",
          cellRenderer: GridConfig.CommandCellRenderer,
          minWidth: appConstants.columnWidth.TERMINAL_COMMANDS,
          maxWidth: appConstants.columnWidth.TERMINAL_COMMANDS,
          filter: false
        },
      ]
    }
  }
}

